import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractRecord, extractFullMessages } from '@/utils/extract'
import { formatDisplayDate } from '@/utils/date'
import { AGENCY_QUOTATION_INIT_LOADING, AGENCY_QUOTATION_INIT_SUCCESS, AGENCY_QUOTATION_INIT_FAIL, QUOTE_MOTOR_PARAM, QUOTE_MOTOR_GENERAL, QUOTE_MOTOR_PARAM_STATS_FAIL, QUOTE_MOTOR_PARAM_STATS, QUOTE_MOTOR_PARAM_STATS_LOADING, QUOTE_MOTOR_STATISTICS, QUOTE_MOTOR_PARAM_EXCESS, QUOTE_MOTOR_PARAM_EXCESS_LOADING, QUOTE_MOTOR_PARAM_EXCESS_FAIL, QUOTE_MOTOR_EXCESS, QUOTE_MOTOR_PARAM_ADDBEN, QUOTE_MOTOR_PARAM_ADDBEN_LOADING, QUOTE_MOTOR_PARAM_ADDBEN_FAIL, QUOTE_MOTOR_ADDBENS, AGENCY_QUOTATION_PREM_LOADING, AGENCY_QUOTATION_PREM_SUCCESS, AGENCY_QUOTATION_PREM_FAIL, QUOTE_MOTOR_PARAM_PLAN_LOADING, QUOTE_MOTOR_PARAM_PLAN_SUCCESS, QUOTE_MOTOR_PARAM_PLAN_FAIL, AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_RESET_BENEFIT } from '@/store/types'

export const motor = {
  async motorQuoteInit({ commit, state }) {
    let apiUrl = state.quotationSettings.menu.motor
    if (apiUrl) {
      const expand = {
        intermediary: state.quotation.commonForm.intermediary
      }
      apiUrl = expandURI(apiUrl, expand)
      commit(AGENCY_QUOTATION_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(AGENCY_QUOTATION_INIT_SUCCESS, commitResult)
        if (commitResult.hasContent) {
          commit(QUOTE_MOTOR_PARAM, commitResult.data)
        }
      } catch (error) {
        commit(AGENCY_QUOTATION_INIT_FAIL)
      }
    } else {
      commit(AGENCY_QUOTATION_INIT_FAIL, ['Invalid API URL'])
    }
  },
  async motorQuoteGeneral({ commit, state, dispatch }, data) {
    // Before committing the data, we will check what is affected by the change of motorQuoteGeneral fields
    const quoteForm = state.quotation.motorForm
    const commonForm = state.quotation.commonForm
    // Check if there is a change of busCls
    if (!quoteForm.busCls || quoteForm.busCls !== data.busCls) {
      await Promise.all([
        dispatch('motorQuoteStatistics', data.busCls),
        dispatch('motorQuoteExcess', { busCls: data.busCls, cover: data.cover }),
        dispatch('motorQuoteAddBenefits', { busCls: data.busCls, tariff: data.tariff, startDate: data.startDate })
      ])
    } else if (!quoteForm.cover || quoteForm.cover !== data.cover) {
      await dispatch('motorQuoteExcess', { busCls: data.busCls, cover: data.cover })
    } else if (!quoteForm.tariff || quoteForm.cover !== data.tariff || !commonForm.startDate || commonForm.startDate !== data.startDate) {
      await dispatch('motorQuoteAddBenefits', { busCls: data.busCls, tariff: data.tariff, startDate: data.startDate })
    }

    // Resolve ncdPct from ncdYr
    if (data.ncdRate !== null && state.quotation.motorParam.ncdRate && state.quotation.motorParam.ncdRate.length > 0) {
      const ncdRecord = extractRecord(state.quotation.motorParam.ncdRate, data.ncdRate)
      Object.assign(data, {
        ncdPct: ncdRecord.secondaryValue
      })
    }

    // Commit the data
    commit(QUOTE_MOTOR_GENERAL, data)
  },
  async motorQuoteStatistics({ commit, state }, busCls) {
    const expand = {
      busCls: busCls
    }
    let apiUrl = state.quotation.menu.statistics
    if (apiUrl) {
      apiUrl = expandURI(apiUrl, expand)
      try {
        commit(QUOTE_MOTOR_PARAM_STATS_LOADING)
        const result = await http.get(apiUrl)
        const { data } = result
        if (data.hasContent) {
          commit(QUOTE_MOTOR_PARAM_STATS, data.data)
          if (state.quotation.motorParam.statistics && state.quotation.motorParam.statistics.length > 0) {
            const commitStats = []
            for (let statsParam of state.quotation.motorParam.statistics) {
              // Check for existing stats val
              let exist = false
              if (state.quotation.motorForm.statistics && state.quotation.motorForm.statistics.length > 0) {
                for (let statsForm of state.quotation.motorForm.statistics) {
                  if (statsForm.key === statsParam.value) {
                    commitStats.push(statsForm)
                    exist = true
                    break
                  }
                }
              }
              if (!exist) {
                // Default the value
                commitStats.push({
                  key: statsParam.value,
                  value: statsParam.defStatsVal !== null ? statsParam.defStatsVal : undefined
                })
              }
            }
            commit(QUOTE_MOTOR_STATISTICS, commitStats)
          } else {
            commit(QUOTE_MOTOR_STATISTICS, [])
          }
        } else {
          commit(QUOTE_MOTOR_PARAM_STATS, [])
        }
      } catch (error) {
        console.log(error)
        commit(QUOTE_MOTOR_PARAM_STATS_FAIL)
      }
    } else {
      commit(QUOTE_MOTOR_PARAM_STATS_FAIL)
    }
  },
  async motorQuoteExcess({ commit, state }, { busCls, cover, toDefault = true }) {
    const expand = {
      busCls: busCls,
      cvrType: cover
    }
    let apiUrl = state.quotation.menu.excess
    if (apiUrl) {
      apiUrl = expandURI(state.quotation.menu.excess, expand)
      try {
        commit(QUOTE_MOTOR_PARAM_EXCESS_LOADING)
        const result = await http.get(apiUrl)
        const { data } = result
        if (data.hasContent) {
          commit(QUOTE_MOTOR_PARAM_EXCESS, data.data)

          // For Excess, we have to check (def && non addable) 1st (as this value is fixed)
          // Then we check existing value
          // Finally add those def && addable
          const hasInited = state.quotation.motorForm.excess && state.quotation.motorForm.excess.length > 0

          if (state.quotation.motorParam && state.quotation.motorParam.excess.length > 0) {
            const commitExcess = []
            for (let excessParam of state.quotation.motorParam.excess) {
              // Def && addable
              if (excessParam.defExcess && !excessParam.addable) {
                commitExcess.push({
                  key: excessParam.value,
                  value: excessParam.amount
                })
              } else {
                // Check existing
                let exist = false
                if (state.quotation.motorForm.excess && state.quotation.motorForm.excess.length > 0) {
                  for (let excessForm of state.quotation.motorForm.excess) {
                    if (excessForm.key === excessParam.value) {
                      commitExcess.push(excessForm)
                      exist = true
                      break
                    }
                  }
                }
                // Def and addable
                if (!exist && excessParam.defExcess && excessParam.addable && !hasInited && toDefault) {
                  commitExcess.push({
                    key: excessParam.value,
                    value: excessParam.amount
                  })
                }
              }
            }
            commit(QUOTE_MOTOR_EXCESS, commitExcess)
          } else {
            commit(QUOTE_MOTOR_EXCESS, [])
          }
        } else {
          commit(QUOTE_MOTOR_PARAM_EXCESS, [])
        }
      } catch (error) {
        console.log(error)
        commit(QUOTE_MOTOR_PARAM_EXCESS_FAIL)
      }
    } else {
      commit(QUOTE_MOTOR_PARAM_EXCESS_FAIL)
    }
  },
  async motorQuotePlans({ commit, state }) {
    const apiUrl = state.quotation.menu.mtrPlans
    if (apiUrl) {
      try {
        commit(QUOTE_MOTOR_PARAM_PLAN_LOADING)

        const result = await http.post(apiUrl, motorCalcForm(state))
        const { data } = result
        commit(QUOTE_MOTOR_PARAM_PLAN_SUCCESS, data)
      } catch (error) {
        commit(QUOTE_MOTOR_PARAM_PLAN_FAIL)
      }
    } else {
      commit(QUOTE_MOTOR_PARAM_PLAN_FAIL)
    }
  },
  async motorQuoteAddBenefits({ commit, state }, { busCls, tariff, startDate }) {
    const expand = {
      busCls,
      tariff,
      startDate: formatDisplayDate(startDate)
    }
    const apiUrl = expandURI(state.quotation.menu.addBenefits, expand)
    if (apiUrl) {
      try {
        commit(QUOTE_MOTOR_PARAM_ADDBEN_LOADING)
        const result = await http.get(apiUrl)
        const { data } = result
        if (data.hasContent) {
          commit(QUOTE_MOTOR_PARAM_ADDBEN, data.data)
          if (state.quotation.motorParam.addBenefits && state.quotation.motorParam.addBenefits.length > 0 &&
            state.quotation.motorForm.addBenefits && state.quotation.motorForm.addBenefits !== null && state.quotation.motorForm.addBenefits.length > 0) {
            let commitAddBens = []
            for (let addBenForm of state.quotation.motorForm.addBenefits) {
              for (let addBenParam of state.quotation.motorParam.addBenefits) {
                // Check for existing add Ben
                if (addBenForm === addBenParam.value) {
                  // Default the value
                  commitAddBens.push(addBenForm)
                  break
                }
              }
            }
            // If its 0 by the end of the check, reset it to null so when it recalculates, it will get the defaults
            if (commitAddBens.length === 0) {
              commitAddBens = null
            }
            commit(QUOTE_MOTOR_ADDBENS, commitAddBens)
          } else {
            commit(QUOTE_MOTOR_ADDBENS, null)
          }
        } else {
          commit(QUOTE_MOTOR_PARAM_ADDBEN, [])
        }
      } catch (error) {
        console.log(error)
        commit(QUOTE_MOTOR_PARAM_ADDBEN_FAIL)
      }
    } else {
      commit(QUOTE_MOTOR_PARAM_ADDBEN_FAIL)
    }
  },
  async motorQuoteCalculate({ commit, state }) {
    const apiUrl = state.quotation.menu.getPremium
    if (apiUrl) {
      try {
        commit(AGENCY_QUOTATION_PREM_LOADING)
        const { commonInfo, motorParam } = state.quotation
        // const { motorForm, commonInfo, motorParam } = state.quotation

        // Compile the premium object
        const calculateObj = motorCalcForm(state)
        const result = await http.post(apiUrl, calculateObj)
        commit(AGENCY_QUOTATION_PREM_SUCCESS, result.data)

        // Default those "addable-defaulted" benefits to addben
        // Do this only when addBenefits is undefined or null (means it will only default the 1st time)
        // if (!motorForm.addBenefits || motorForm.addBenefits === null) {
        commit(AGENCY_QUOTATION_RESET_BENEFIT)
        const pushBenefits = []
        if (commonInfo.premium.benefits && commonInfo.premium.benefits.length > 0 && motorParam.addBenefits && motorParam.addBenefits.length > 0) {
          for (let benefit of commonInfo.premium.benefits) {
            if (motorParam.addBenefits.find(a => a.value === benefit.value)) {
              pushBenefits.push(benefit.value)
            }
          }
        }
        if (pushBenefits.length > 0) {
          // Commit only if there is something, else remain null for next default (if user change values infront)
          commit(QUOTE_MOTOR_ADDBENS, pushBenefits)
        }
        // }
      } catch (error) {
        commit(AGENCY_QUOTATION_PREM_FAIL, extractFullMessages(error))
      }
    } else {
      commit(AGENCY_QUOTATION_PREM_FAIL, ['Invalid API URL'])
    }
  },
  async revertMtrQuote({ commit, state, dispatch }) {
    const apiUrl = state.quotation.menu.revertQuote
    if (apiUrl) {
      commit(AGENCY_QUOTATION_SAVE_LOADING)
      try {
        const submitForm = {
          proposalNo: state.quotation.commonForm.proposalNo,
          revision: state.quotation.commonForm.revision,
          appID: state.quotation.commonForm.appID
        }
        const result = await http.post(apiUrl, submitForm)
        // After success push to quotation page
        const dispatchObj = {
          proposalNo: result.data.proposalNo,
          query: false
        }
        await dispatch('loadQuote', dispatchObj)

        commit(AGENCY_QUOTATION_SAVE_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          commit(AGENCY_QUOTATION_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Fail to revert Quotation/Proposal Status to NQ']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Invalid API URL']))
      const err = { message: 'Invalid API URL' }
      throw err
    }
  }
}

export const motorCalcForm = (state) => {
  const { commonForm, motorForm } = state.quotation
  let mainDrv = {}
  if (motorForm.drivers && motorForm.drivers.length > 0) {
    mainDrv = motorForm.drivers[0]
  }
  return {
    appID: commonForm.appID,
    intermediary: commonForm.intermediary,
    product: commonForm.product,
    busCls: motorForm.busCls,
    tariff: motorForm.tariff,
    cover: motorForm.cover,
    acceptDate: commonForm.acceptDate,
    startDate: commonForm.startDate,
    endDate: commonForm.endDate,
    campaign: commonForm.campaign,
    promotion: commonForm.promotion,
    adjDiscount: commonForm.adjDiscount,
    ncdPct: motorForm.ncdPct,
    drvExp: mainDrv.drvExp,
    drvMarital: mainDrv.drvMarital,
    drvGender: mainDrv.drvGender,
    drvDob: mainDrv.drvDob,
    drvOccupation: mainDrv.drvOccupation,
    vehMake: motorForm.vehMake,
    vehModel: motorForm.vehModel,
    vehValue: motorForm.vehValue,
    vehRegYr: motorForm.vehRegYr,
    statistics: motorForm.statistics,
    excess: motorForm.excess,
    addBenefits: motorForm.addBenefits
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}
